import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import ReactivateUserKeys from '../../constants/locale/key/ReactivateUser'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let maxLengthErrorMessage = translate(
    Namespace.REACTIVATE_USER,
    ReactivateUserKeys.Validations.ERROR_MSG_MAX_LENGTH
  )

  return Yup.object({
    userId: Yup.string().max(50, maxLengthErrorMessage + " 50").required(requiredMessage).nullable(),
  })
}

export default makeValidationSchema
